import { setTag as setMonitorTag } from '@sentry/react';

/**
 * Set tag only once per page lifecycle
 */
export function setMonitorTagOnce(tag: string, value: string) {
    const currentlySetTag = monitoringTagsSet.get(tag);
    if (currentlySetTag === value) {
        return; // Tag already set
    }

    setMonitorTag(tag, value);
    monitoringTagsSet.set(tag, value);
}

const monitoringTagsSet = new Map<string, string>();
